module.exports = __webpack_public_path__ + "static/media/promote-custom-merchandising.6dba4a13.png";